import { render, staticRenderFns } from "./Hijri.vue?vue&type=template&id=10d6b214&"
import script from "./Hijri.vue?vue&type=script&lang=js&"
export * from "./Hijri.vue?vue&type=script&lang=js&"
import style0 from "./Hijri.vue?vue&type=style&index=0&id=10d6b214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports